import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import AmbientThreads from './AmbientThreads';
const ProductStory = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(entries => entries[0].isIntersecting && setVisible(true), {
      threshold: 0.2
    });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={sectionRef} className="relative overflow-hidden py-24 md:py-32" style={{
    backgroundColor: 'var(--ivory)'
  }} data-id="element-200">
      <AmbientThreads variant="minimal" data-id="element-201" />

      <div className="relative max-w-5xl mx-auto px-6 sm:px-8 lg:px-10 text-center" data-id="element-202">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={visible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-xs tracking-widest uppercase mb-6" style={{
        color: 'var(--coral)'
      }} data-id="element-203">
          The Emigo Philosophy
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 24
      }} animate={visible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.9,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-3xl md:text-5xl lg:text-6xl leading-[1.15] font-normal tracking-tight" style={{
        color: 'var(--navy)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-204">
          A single message can break a bond, or build one.{' '}
          <span className="italic" style={{
          color: 'var(--coral)'
        }} data-id="element-205">
            Emigo turns impulse into reflection.
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={visible ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.9,
        delay: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="mt-8 max-w-2xl mx-auto text-base md:text-lg leading-relaxed" style={{
        color: 'var(--muted)'
      }} data-id="element-206">
          A calm, emotionally intelligent companion that helps you choose
          connection, one conversation at a time.
        </motion.p>
      </div>
    </section>;
};
export default ProductStory;